import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
  PayloadAction,
  SerializedError,
} from '@reduxjs/toolkit'
import { SearchItem } from '../types/search'
import { searchApi } from '../api/api'

// get book authors and publishers by name
export const searchByName = createAsyncThunk(
  'search/searchByName',
  async ({ name, language }: { name: string; language: string }, thunkApi) => {
    try {
      return await searchApi.searchBooksByName(name, language)
    } catch (e) {
      return thunkApi.rejectWithValue('searchByNameError')
    }
  },
)

interface SearchSliceState {
  foundBooks: SearchItem[]
  foundAuthors: SearchItem[]
  foundPublishers: SearchItem[]
  searchPageFoundBooks: SearchItem[]
  searchPageFoundAuthors: SearchItem[]
  searchPageFoundPublishers: SearchItem[]
  loading: boolean
  error?: SerializedError
}

const initialState: SearchSliceState = {
  foundBooks: [],
  foundAuthors: [],
  foundPublishers: [],
  searchPageFoundBooks: [],
  searchPageFoundAuthors: [],
  searchPageFoundPublishers: [],
  loading: false,
  error: undefined,
}

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    resetFoundResults: (
      state: SearchSliceState,
      action: PayloadAction<any>,
    ) => {
      state.foundBooks = []
      state.foundAuthors = []
      state.foundPublishers = []
    },

    setSearchPageFoundResults: (
      state: SearchSliceState,
      action: PayloadAction<any>,
    ) => {
      state.searchPageFoundBooks = state.foundBooks
      state.searchPageFoundAuthors = state.foundAuthors
      state.searchPageFoundPublishers = state.foundPublishers
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<any>) => {
    // get all publishers
    // @ts-ignore
    builder.addCase(
      searchByName.fulfilled,
      (state: SearchSliceState, action: PayloadAction<any>) => {
        state.foundBooks = action.payload.foundBooks
        state.foundAuthors = action.payload.foundAuthors
        state.foundPublishers = action.payload.foundPublishers
        state.loading = true
        state.error = undefined
      },
    )

    builder.addCase(searchByName.pending, (state: SearchSliceState, action) => {
      state.loading = false
      state.error = undefined
    })

    builder.addCase(searchByName.rejected, (state, action) => {
      state.loadedAllAuthors = true
      state.error = action.payload
    })
  },
})

export const { resetFoundResults, setSearchPageFoundResults } =
  searchSlice.actions
export default searchSlice
